import React, { useEffect, useState } from 'react';
import SupplierPartModal from '@/js/components/modals/SupplierPartModal';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import createApiClient from '@/api/axiosInstance';
import { format } from 'date-fns';
import { ChevronLeft } from 'lucide-react';

const companyData = [
  {
    ID: '#RFQ-0012',
    company: 'Ronald Industries',
  },
];

const cardData = [
  {
    name: 'medical device.bom',
    size: '10MB',
    img: 'C:\Users\kapoo\OneDrive\Pictures\Screenshots\Screenshot 2025-05-16 020933.png',
  },
  {
    name: 'Diagram file',
    size: '10MB',
    img: 'C:\Users\kapoo\OneDrive\Pictures\Screenshots\Screenshot 2025-05-16 020933.png',
  },
  {
    name: 'project.doc',
    size: '10MB',
    img: 'C:\Users\kapoo\OneDrive\Pictures\Screenshots\Screenshot 2025-05-16 020933.png',
  },
];
const cardData2 = [
  {
    name: 'CAD',
    size: '10MB',
    img: 'C:\Users\kapoo\OneDrive\Pictures\Screenshots\Screenshot 2025-05-16 020933.png',
  },
];

const Skeleton = ({ width = 'w-full', height = 'h-4' }) => (
  <div className={`bg-gray-200 rounded ${width} ${height} animate-pulse`}></div>
);

const RFQPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const apiClient = createApiClient(navigate, dispatch);
  const { data } = location.state;
  const { rfqId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [rfqData, setRfqData] = useState({});
  const [parts, setParts] = useState([]);
  const [project, setProject] = useState({});

  const [showPartModal, setShowPartModal] = useState(false);
  const [selectedPart, setSelectedPart] = useState(null);

  const handleAddQuote = (part) => {
    setSelectedPart(part);
    setShowPartModal(true);
  };

  const SubmitQuote = async (quoteData) => {
    setIsLoading(true);
    try {
      const payload = {
        ...quoteData,
        quote_validity: format(
          new Date(quoteData.quote_validity),
          'dd-MM-yyyy',
        ),
        rfq_id: 123,
        project_id: project.project_id,
        manufacturer_id: data.manufacturer_id,
        buyer_id: data.buyer_id,
        part_id: selectedPart.part_id,
        part_version_id: selectedPart.part_version_id,
        payment_term: data.payment_term,
      };

      const response = await apiClient.post(
        '/api/quotation/create',
        JSON.stringify(payload),
      );

      setShowPartModal(false);
      setSelectedPart(null);
      console.log('Quote submitted successfully:', response.data);
    } catch (error) {
      console.error('Error submitting quote:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchRfqData = async () => {
      try {
        setIsLoading(true);
        const response = await apiClient.post(
          '/api/rfq/get/quote-number',
          JSON.stringify({
            quote_number: rfqId,
          }),
        );

        const responseData = response.data;

        setRfqData(responseData.data);
        setProject(responseData.data.project_part_response.project);
        setParts(responseData.data.project_part_response.parts);
      } catch (error) {
        console.error('Error fetching RFQ data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRfqData();
  }, []);

  return (
    <div className="font-roboto mr-4">
      <div
        className="flex items-center gap-2 pb-5 my-2 cursor-pointer"
        onClick={() => navigate('/supplier/dashboard')}
      >
        <ChevronLeft className="h-6 w-6" />
        <h2 className="font-semibold text-lg">Request for Quotation</h2>
      </div>
      <div className="w-full p-4 rounded-lg bg-gray-50">
        <div className="flex justify-between items-center bg-gray-100 p-2 rounded-lg">
          <div className="flex items-center space-x-4 ">
            <span className="text-gray-500 pr-5">RFQ ID</span>
            <span className="font-medium pl-1 m-0">{data.quote_number}</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-gray-500">Submit By:</span>
            <span>
              {format(new Date(data.rfq_submission_deadline), 'd MMMM, yyyy')}
            </span>
          </div>
        </div>

        <div className="flex flex-row items-center gap-6 p-2 mt-2">
          <span className="inline-block">
            <img
              src="/api/placeholder/120/120"
              alt="Company logo"
              className="rounded h-16 w-16"
            />
          </span>
          <div className="flex-1">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-col">
                <div className="flex items-center gap-3">
                  <div className="text-2xl font-medium">
                    {companyData[0].company}
                  </div>
                  <span className="text-gray-400">USA, Washington</span>
                </div>
                <div>
                  <span className="text-darkerPurple font-semibold hover:cursor-pointer hover:text-darkerPurple transition-all ease-in duration-200">
                    View profile
                  </span>
                </div>
              </div>
              <div className="">
                <button className="bg-darkPurple border border-purple-800 text-white py-2 px-4 text-base rounded mr-6 hover:bg-darkerPurple transition-all ease-in duration-300">
                  Accept
                </button>
                <button className="bg-white border border-darkPurple rounded text-darkPurple py-2 px-4 text-base font-semibold hover:bg-gray-100 transition-all ease-in duration-300">
                  Decline
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 bg-gray-50 p-4 rounded-lg">
        {/* <div className="bg-gray-100 p-2 rounded-lg">Product Details</div> */}
        <div className="">
          <p className="text-gray-600">Description</p>
          <div className="bg-gray-100 p-3 rounded mt-2">
            {project.description}
          </div>
        </div>
      </div>

      <div className="mt-8 bg-gray-50 p-4 rounded-lg">
        <div className="text-darkPurple font-semibold text-lg bg-gray-100 p-2 rounded-lg">
          Overall Product Details
        </div>
        <div className="p-2 mt-2">
          <div className="text-gray-500 font-medium pb-2">
            Total Quantity Of Manufacture
          </div>
          <div className="bg-gray-100 px-3 py-1.5 w-1/3 rounded-sm">
            {project.total_quantity_to_manufacture}
          </div>

          <div className="mt-5">
            <div className="text-gray-500 pt-6 font-medium">
              Product Dimensions
            </div>
            <div className="flex flex-row gap-3 mt-2">
              <div className="bg-gray-100 px-3 py-1.5 rounded w-96">
                <span className="text-base">{project.product_length}</span>
                <span className="text-sm text-gray-400 ml-1">(Length)</span>
              </div>
              <div className="bg-gray-100 px-3 py-1.5 rounded w-96">
                <span className="text-base">{project.product_width}</span>
                <span className="text-sm text-gray-400 ml-1">(Width)</span>
              </div>
              <div className="bg-gray-100 px-3 py-1.5 rounded w-96">
                <span className="text-base">{project.product_height}</span>
                <span className="text-sm text-gray-400 ml-1">(Height)</span>
              </div>
              <div className="bg-gray-100 px-3 py-1.5 rounded w-40">
                <span className="text-base">
                  {project.product_dimension_uom}
                </span>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <div className="text-gray-500 pt-6 font-medium">
              Estimated Weight
            </div>
            <div className="flex gap-3">
              <div className="bg-gray-100 px-3 py-1.5 rounded w-1/3 ">
                {project.product_weight}
              </div>
              <div className="bg-gray-100 px-3 py-1.5 rounded w-40 text-sm">
                {project.product_weight_uom}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 mt-8 p-4 rounded-lg">
        <div className="text-darkPurple font-semibold text-lg bg-gray-100 p-2 rounded-lg">
          Part Details
        </div>

        <div>
          <table className="w-full border-separate border-spacing-y-4">
            <thead>
              <tr className="text-black text-md text-left bg-veryVeryLightPurple">
                <th className="px-4 pt-2 whitespace-nowrap font-thin text-center rounded-l-lg border-t border-b border-l border-gray-300">
                  Image
                </th>
                <th className="px-4 pt-2 text-center font-thin border-t border-b border-gray-300">
                  Part Name
                </th>
                <th className="px-4 pt-2 whitespace-nowrap text-center font-thin border-t border-b border-gray-300">
                  Part Number
                </th>
                <th className="px-4 pt-2 text-center font-thin border-t border-b border-gray-300">
                  Estimated <br /> Total Cost($)
                </th>
                <th className="px-4 pt-2 font-thin border-t border-b border-gray-300">
                  Quantity
                </th>
                <th className="px-4 pt-2 font-thin border-t border-b border-gray-300">
                  Lead Time
                </th>
                <th className="px-4 pt-2 font-thin rounded-r-lg border-t border-b border-r border-gray-300">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {parts.map((item, index) => (
                <tr
                  key={index}
                  className="bg-white text-sm text-black border border-gray-200 text-left rounded-lg shadow-sm"
                >
                  <td className="px-4 py-3 rounded-l-lg border-t border-b border-l border-gray-400">
                    <img
                      src={item.image}
                      alt="Part"
                      className="w-16 h-16 object-contain mx-auto"
                    />
                  </td>
                  <td className="px-4 py-3 border-t border-b border-gray-400">
                    {item.part_name}
                  </td>
                  <td className="px-4 py-3 border-t border-b border-gray-400 text-center">
                    {item.part_number}
                  </td>
                  <td className="px-4 py-3 border-t border-b border-gray-400 text-center">
                    {item.estimatedCost}
                  </td>
                  <td className="px-4 py-3 border-t border-b border-gray-400">
                    {item.total_parts_required}
                  </td>
                  <td className="px-4 py-3 border-t border-b border-gray-400">
                    {item.leadTime}
                  </td>
                  <td className="px-4 py-3 rounded-r-lg border-t border-b border-r border-gray-400">
                    <button
                      className="border border-purple-500 text-purple-600 px-3 py-1 rounded text-sm hover:bg-purple-50"
                      onClick={() => handleAddQuote(item)}
                    >
                      Add Quote
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-gray-50 mt-12 p-1 rounded text-darkerPurple font-semibold text-lg">
        Documents Attached
      </div>

      <div className="mt-5">
        <div className="flex gap-4">
          {cardData.map((cardItem, index) => (
            <div
              key={index}
              className="w-56 p-4 border border-gray-300 rounded-lg shadow-md"
            >
              <div className="flex">
                <div className="px-2 py-4">
                  <img src="C:\Users\kapoo\OneDrive\Pictures\Screenshots\Screenshot 2025-05-16 020933.png"></img>
                </div>
                <img
                  className="block"
                  src="C:\Users\kapoo\OneDrive\Pictures\Screenshots\Screenshot 2025-05-16 020933.png"
                  alt=""
                />
                <div className="flex flex-col mb-3">
                  <div>
                    <p
                      className="font-medium text-sm truncate"
                      title={cardItem.name}
                    >
                      {cardItem.name}~
                    </p>
                    <p className="text-xs text-gray-500">{cardItem.size}</p>
                  </div>
                  <div className="flex flex-row justify-between">
                    <button className="text-darkPurple">Download</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-5">
        <div className="flex gap-4">
          {cardData2.map((cardItem, index) => (
            <div
              key={index}
              className="w-56 p-4 border border-gray-300 rounded-lg shadow-md "
            >
              <div className="flex">
                <div className="px-2 py-4">
                  <img src="C:\Users\kapoo\OneDrive\Pictures\Screenshots\Screenshot 2025-05-16 020933.png"></img>
                </div>
                <img
                  className="block"
                  src="C:\Users\kapoo\OneDrive\Pictures\Screenshots\Screenshot 2025-05-16 020933.png"
                  alt=""
                />
                <div className="flex flex-col mb-3">
                  <div>
                    <p
                      className="font-medium text-sm truncate"
                      title={cardItem.name}
                    >
                      {cardItem.name}
                    </p>
                    <p className="text-xs text-gray-500">{cardItem.size}</p>
                  </div>
                  <div className="flex flex-row justify-between">
                    <button className="text-darkPurple">Download</button>

                    <img src="C:\Users\kapoo\Downloads\Screenshot_2025-05-16_235407-removebg-preview.png"></img>
                  </div>
                  <div className="relative">
                    <button className="bg-darkPurple text-white font-md w-40 px-4 py-1 rounded hover:bg-darkerPurple">
                      Open File
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-gray-50 mt-8 p-5 rounded-lg mb-10">
        <div className="bg-gray-100 text-darkerPurple font-semibold text-lg p-2 rounded-lg">
          Payment Terms
        </div>
        <div className="mt-5 text-gray-500 font-semibold text-sm">
          Payment terms from {companyData[0].company} Pvt.Ltd
        </div>
        <div className="flex justify-between">
          <div className="bg-gray-50 p-2 mt-2 w-1/3 rounded-sm">
            {data.payment_term}
          </div>
          <button className="bg-gray-50 border border-darkerPurple text-darkerPurple p-3 font-semibold rounded hover:bg-gray-200">
            Change payment method
          </button>
        </div>
      </div>
      <div className="flex justify-center my-4">
        <button className="px-4 py-2 bg-darkPurple text-white rounded-md">
          Submit Quote
        </button>
      </div>
      <SupplierPartModal
        selectedPart={selectedPart}
        open={showPartModal}
        onSubmit={SubmitQuote}
        onClose={() => {
          setShowPartModal(false);
          setSelectedPart(null);
        }}
      />
    </div>
  );
};

export default RFQPage;
